import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { Singleton } from "../../../../../../core/services/Singleton";
import usePaginator from "../../../../../theme/Component/usePaginator";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { _HealthScopeSupport } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { HealthID } from "../../../../../admin/configuracion/HealthID/HealthID";


interface Props {
    idHealthScope: number;
}

export const HealthScopeSupport = ({ idHealthScope }: Props) => {

    const scopesupp = useDataBean(_HealthScopeSupport);
    const paginador = usePaginator();
    const [health, setHealth] = useState<any>(null);
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    useEffect(() => {
        getLista();
    }, [idHealthScope])

    const getLista = () => {

        scopesupp.instance.getHealthScopeSupportCatalog(idHealthScope,regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                   //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        scopesupp.setBean({
            IDHealthScope: idHealthScope
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        scopesupp.instance.deleteVoid(scopesupp.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        scopesupp.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDHealthScopeSupport', visible: true },
        { title: 'Soporte de Pago', property: 'Soporte', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
 const addHealthScopeSupport = () => {
        //console.log(entailment.bean);
        scopesupp.instance.addHealthScopeSupport(idHealthScope,health).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <div className="row">
            <div className="col-md-12">
                <label>Soportes de Pago</label>
            </div>
            <div className="col-md-6">
                                <label>Búsqueda por Texto</label>
                                <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                            </div>
                            <div className="col-md-6 mt-4 p-2">
                                <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={scopesupp.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={addHealthScopeSupport}>
                    <div className="row">
                         <HealthID tipoPresupuesto={null} id={null} edit={true} onSelect={(item) => {
                                                        console.log(item);
                                                        setHealth(item);
                                                            }}/>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}